export enum AgGridFilterType {
  Text = 'text',
  Number = 'number',
  Set = 'set',
  Date = 'date',
}

export enum AgGridFilterComparison {
  Contains = 'contains',
  Equals = 'equals',
  InRange = 'inRange',
}

export type DateFilter = {
  dateFrom: string
  dateTo?: string
  filterType: AgGridFilterType.Date
  type: AgGridFilterComparison.Equals | AgGridFilterComparison.InRange
}

export type TextFilter = {
  filter: string
  filterType: AgGridFilterType.Text
  type: AgGridFilterComparison.Contains
}

export type NumberFilter = {
  filter?: number
  filterTo?: number
  filterType: AgGridFilterType.Number
  type: AgGridFilterComparison.InRange
  currencySymbol?: string
}

export type SetFilter = {
  values: string[]
  filterType: AgGridFilterType.Set
}

export type AgGridFiltersTypes =
  | DateFilter
  | TextFilter
  | NumberFilter
  | SetFilter

export type AgGridFilters<T extends string> = Record<T, AgGridFiltersTypes>

export type OptionProps = {
  content: JSX.Element
  maxHeight?: number
  options?: OptionProps[]
  disabled?: boolean
}

export type FilterChip = {
  name: string
  label: string
  filterType: AgGridFilterType
  value: string
}

export type FilterDef = {
  id: string
  name: string
  label: string
  type: AgGridFilterType
  isCurrency?: boolean
}

export type FilterOptionProps = {
  name: string
  onUpdateFilters: (name: string, value: AgGridFiltersTypes) => void
}

export type ValuesData = Record<
  string,
  { limitValues: { min: number; max: number }; currencySymbol?: string }
>
